const headerNp = {
  brand: 'ग्रामीण बजार',
  top: {
    bazarList: 'बजारहरू',
    help: 'साहाय्यता',
    contact: 'सम्पर्क',
  },
  nav: {
    dailyBazar: 'किराना',
    medicineBazar: 'औषधि',
    foodBazar: 'ताजा खाना',
    grains: 'अन्न',
    nationalBazar: 'राष्ट्रीय',
    garmentsBazar: 'कपडा',
    cosmeticsBazar: 'सौन्दर्य',
    bookBazar: 'पुस्तक',
    nurseryBazar: 'नर्सरी',
    electronicsBazar: 'इलेक्ट्रोनिक्स',
    chemicalBazar: 'रासायनिक',
    hardwareBazar: 'हार्डवेयर',
    serviceBazar: 'सेवा',
    feedBazar: 'पशु आहार',
  },
  search: {
    placeholder: 'के किन्न खोज्दै हुनुहुन्छ?'
  },
  drawer: {
    home: 'होम',
    dailyBazar: 'डेली बजार',
    medicineBazar: 'मेडिसिन बजार',
    grains: 'अन्न बजार',
    nationalBazar: 'नेशनल बजार',
    foodBazar: 'ताजा खाना',
    bookBazar: 'बुक बजार',
    nurseryBazar: 'नर्सरी बजार',
    garmentsBazar: 'गार्मेन्ट्स बजार',
    electronicsBazar: 'इलेक्ट्रोनिक्स बजार',
    chemicalBazar: 'केमिकल बजार',
    hardwareBazar: 'हार्डवेयर बजार',
    cosmeticsBazar: 'कोस्मेटिक्स बजार',
    serviceBazar: 'सर्भिस बजार',
    feedBazar: 'फिड बजार',
  },
  profileMenu: {
    login: 'लगइन',
    register: 'रजिस्टर',
    myAccount: 'मेरो अकाउन्ट',
    storeDashboard: 'स्टोर ड्यासबोर्ड',
    adminDashboard: 'एडमिन ड्यासबोर्ड',
  },
};

export default headerNp;


